import { useFuncionariosOutletContext } from 'pages/Funcionarios'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useStore } from 'store'
import { ExcluirFuncionario } from './Excluir'
import { empresas as empresas_api } from 'service/api'
import { hasPermission } from 'hooks/useBackendMenu'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { DadosPessoaisForm } from '../forms/DadosPessoais'
import { AdicionaisForm } from '../forms/Adicionais'
import { CentroCustoForm } from '../forms/CentroCusto'

export default function DetalhesFuncionario() {
    const { funcionarioId } = useParams()
    const { data } = useFuncionariosOutletContext()
    const [open, setOpen] = useState(false)

    const row = data?.find(item => item.id === Number(funcionarioId))!
    const empresaId = useStore(state => state.companyId)
    const { data: empresas } = empresas_api.useFetch({ enabled: empresaId > 0 })
    const empresaUsaBancoHoras =
        (empresas?.find(empresa => empresa.id === empresaId)
            ?.periodoFechamentoPonto || 0) > 0

    if (!row) return null

    return (
        <TabbedDialog.Root
            disableFields
            tabs={[
                {
                    name: 'dados',
                    label: 'Dados básicos',
                    content: <DadosPessoaisForm editar />,
                },
                {
                    name: 'adicionais',
                    label: 'Adicionais',
                    content: <AdicionaisForm />,
                },
                {
                    name: 'centro-custo',
                    label: 'Centro de Custo',
                    content: <CentroCustoForm />,
                },
            ]}
            onSubmit={() => setOpen(true)}
            defaultValues={{
                ...row,
                uf: row.Cidade?.uf,
                tabelaHorarioId: row.TabelaHorario?.id,
                empresaUsaBancoHoras,
            }}
        >
            <TabbedDialog.Title>Detalhes do funcionário</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            {!!row && (
                <ExcluirFuncionario
                    open={open}
                    onClose={() => setOpen(false)}
                    funcionario={row}
                />
            )}
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                {hasPermission(['delete', 'Funcionários'], () => (
                    <TabbedDialog.Actions.PrimaryButton color="error">
                        Excluir
                    </TabbedDialog.Actions.PrimaryButton>
                ))}
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
